var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationConfettiRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.113695 6.91565C3.15887 10.8786 7.94415 11.3149 10.5422 15.1931L13.5391 11.3876C11.0014 7.43678 6.15571 7.0732 3.11054 3.11023L0.113695 6.91565Z",
    fill: "#1D873E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3678 52.7841C28.9303 50.8829 30.6457 46.2424 35.0176 44.7664L32.242 40.7013C27.8224 42.1022 26.1547 46.8178 21.5922 48.719L24.3678 52.7841Z",
    fill: "#80E49F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0827 31.9748C35.6451 30.1792 37.3605 25.7965 41.7324 24.4025L38.9568 20.5632C34.5373 21.8863 32.8695 26.3399 28.3071 28.1355L31.0827 31.9748Z",
    fill: "#419791"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7291 40.7012C15.0412 40.7012 15.3412 40.5819 15.5813 40.3551L17.982 37.9677C18.4501 37.5021 18.4501 36.7501 17.982 36.2845C17.5138 35.819 16.7576 35.819 16.2895 36.2845L13.8888 38.6719C13.4207 39.1375 13.4207 39.8895 13.8888 40.3551C14.1289 40.5938 14.429 40.7012 14.7411 40.7012H14.7291ZM49.5386 13.2462C49.8507 13.2462 50.1508 13.1268 50.3908 12.9L52.7915 10.5126C53.2596 10.0471 53.2596 9.29505 52.7915 8.8295C52.3234 8.36396 51.5671 8.36396 51.099 8.8295L48.6984 11.2169C48.2302 11.6824 48.2302 12.4345 48.6984 12.9C48.9384 13.1388 49.2385 13.2462 49.5506 13.2462H49.5386Z",
    fill: "#1D873E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8501 5.12405C34.1543 5.12405 34.4703 5.00411 34.6926 4.75224C35.1373 4.27248 35.1256 3.51685 34.6575 3.06108L32.2937 0.758236C31.8256 0.302464 31.0883 0.314456 30.6437 0.794216C30.199 1.27398 30.2107 2.0296 30.6788 2.48537L33.0426 4.78822C33.265 5.00411 33.5575 5.12405 33.8501 5.12405Z",
    fill: "#419791"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationConfettiRight);
export default __webpack_public_path__ + "static/media/illustration--confetti-right.2c69ab0ef3d3fead0c84035e15e68c02.svg";
export { ForwardRef as ReactComponent };